<template>
  <div class="container">
    <Snowf v-if="current_month==11"
      :amount="50"
      :size="5"
      :speed="1.5"
      :wind="0"
      :opacity="0.8"
      :swing="1"
      :image="null"
      :zIndex="null"
      :resize="true"
      color="#fff"
    />
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card  border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-6 d-none d-lg-block bg-login-image"></div>
              <div class="col-lg-6">
                <div class="p-5">
                  <div class="text-center">
                    <img class="img-responsive" id="logo" src="../../public/images/Shift2DC_logo.png">
                    <h1 class="h5 text-gray-900 mb-4">{{ $t('Welcome_back') }}!</h1>
                    <div v-if="auth_status == 'error'" class="alert alert-danger" role="alert">
                      {{ $t('Wrong_credentials') }}
                    </div>
                    <div v-if="error_message" class="alert alert-danger" role="alert">
                      {{ error_message }}
                    </div>
                  </div>
                  <form class="user" v-on:submit="login">
                    <div class="form-group">
                      <input type="username" v-model="input.username" class="form-control form-control-user" id="exampleInputEmail" aria-describedby="emailHelp" :placeholder="$t('Email_address')">
                    </div>
                    <div class="form-group">
                      <input autocomplete="off" type="password" v-model="input.password" class="form-control form-control-user" id="exampleInputPassword" :placeholder="$t('Password')">
                    </div>
                    <input type="submit" :value="$t('Login')" class="btn btn-primary btn-user btn-block">
                  </form>
                  <hr>
                  <div class="text-center">
                    <router-link class="small" to="/forgot">{{ $t('Forgot_password') }}</router-link>
                  </div>
                  <div class="text-center mt-2">
                    <SelectLanguage></SelectLanguage>
                  </div>
                </div> 
              </div>
            </div>
          </div>
          <div class="card-footer" style="background-color: #111827; border: 1px solid grey">
            The Funchal Port Demonstrator in Madeira Island focuses on DC integration and Digital Twin technology to enhance port efficiency and sustainability. This project, funded by European Union´s Horizon Europe research and innovation programme, aims to reduce carbon emissions in line with IMO goals. The demonstrator explores four main use cases, including energy buffering for cruise ships and port-grid coordination, with contributions from ITI, APRAM, INESC ID, EDP NEW, FINCANTIERI, CIRCE, and EDF.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectLanguage from './SelectLanguage.vue'
import axios from "axios"
import Snowf from 'vue-snowf'
import Footer from './Footer.vue'

export default {
  name: 'Login',
  components:{
    SelectLanguage,
    Snowf,
    Footer
  },
  data(){
    return {
      input:{
        username: "",
        password: ""
      }
    }
  },
  methods: {
    login: function(e){
      e.preventDefault()
      const data = {
        username: this.input.username,
        password: this.input.password
      }
      this.$store.dispatch('login', data).then(() => { this.$router.push('/') })
    }
  },
  computed: {
    auth_status: function(){
      return this.$store.getters.authStatus
    },
    error_message: function(){
      return this.$route.params.message ? this.$route.params.message : null
    },
    current_month: function () {
      return (new Date()).getMonth()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-login-image{
  background: url("../../public/images/madeira_port.jpg");
  background-position: center;
  background-size: cover;
}

#logo{
  max-height: 130px;
}

.row {
  margin-left: unset;
}
</style>
